var map = {
	"./champions_league.embedded.svg": 1236,
	"./conmebol_icon.embedded.svg": 1237,
	"./csgo_icon.embedded.svg": 1238,
	"./dota2_icon.embedded.svg": 1239,
	"./dreamhack_icon.embedded.svg": 1240,
	"./esl_icon.embedded.svg": 1241,
	"./fnatic_icon.embedded.svg": 1242,
	"./i_league_icon.embedded.svg": 1243,
	"./logo-12up.embedded.svg": 527,
	"./logo-90min.embedded.svg": 528,
	"./logo-dbltap.embedded.svg": 529,
	"./logo-ei.embedded.svg": 530,
	"./logo-floor8.embedded.svg": 531,
	"./logo-ftb90.embedded.svg": 532,
	"./logo-german_site.embedded.svg": 533,
	"./logo-ht_media.embedded.svg": 534,
	"./logo-pluralist.embedded.svg": 535,
	"./lol_icon.embedded.svg": 1244,
	"./mdl_icon.embedded.svg": 1245,
	"./melee_icon.embedded.svg": 1246,
	"./mlb_icon.embedded.svg": 1247,
	"./mls_icon.embedded.svg": 1248,
	"./nba_icon.embedded.svg": 1249,
	"./ncaa-basketball_icon.embedded.svg": 1250,
	"./ncaa-football_icon.embedded.svg": 1251,
	"./nfl_icon.embedded.svg": 1252,
	"./overwatch_icon.embedded.svg": 1253,
	"./powered-by-ei.embedded.svg": 536,
	"./powered-by-german_site.embedded.svg": 537,
	"./powered-by-ht_media.embedded.svg": 538,
	"./smash4_icon.embedded.svg": 1254,
	"./streetfighter_icon.embedded.svg": 1255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1266;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1266
// module chunks = 30